import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupContactComponent } from './popup-contact.component';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
    providers: [PopupContactComponent]

})
export class FooterComponent implements OnInit {

  constructor(private dialogService: DialogService) { }

  ngOnInit() {
  }

showPopUp(){
    let disposable = this.dialogService.addDialog(PopupContactComponent, {
            title: 'Contact Information',
            message: ''
        })
            .subscribe((isConfirmed) => {
                //We get dialog result
                if (isConfirmed) {

                }
                else {
                }
            });
}

}



// WEBPACK FOOTER //
// ./src/app/common/footer.component.ts